import { getStandardButtonStyles } from "../../styles/standardButtons";
import React, { useState, useEffect, useRef, useContext } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";

import api, { getMediaUrl } from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import {
  AccessTime,
  AddCircle,
  Delete,
  Image,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Message,
  MicNone,
  Videocam,
  InsertDriveFile,
} from "@mui/icons-material";
import { capitalize } from "../../utils/capitalize";
import { Box } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const FlowBuilderSingleBlockModal = ({
  open,
  onSave,
  onUpdate,
  data,
  close,
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [rule, setRule] = useState();

  const [medias, setMedias] = useState([]);

  const [textDig, setTextDig] = useState();

  const [elements, setElements] = useState([]);

  const [elementsSeq, setElementsSeq] = useState([]);

  const [elementsSeqEdit, setElementsSeqEdit] = useState([]);

  const [elementsEdit, setElementsEdit] = useState([]);

  const [name, setName] = useState(""); // Added name state

  const [numberMessages, setNumberMessages] = useState(0);

  const [numberMessagesLast, setNumberMessagesLast] = useState(0);

  const [numberInterval, setNumberInterval] = useState(0);

  const [numberIntervalLast, setNumberIntervalLast] = useState(0);

  const [numberAudio, setNumberAudio] = useState(0);

  const [numberAudioLast, setNumberAudioLast] = useState(0);

  const [numberVideo, setNumberVideo] = useState(0);

  const [numberVideoLast, setNumberVideoLast] = useState(0);

  const [numberImg, setNumberImg] = useState(0);

  const [numberImgLast, setNumberImgLast] = useState(0);

  const [loading, setLoading] = useState(false);

  const [previewImg, setPreviewImg] = useState([]);

  const [previewAudios, setPreviewAudios] = useState([]);

  const [previewVideos, setPreviewVideos] = useState([]);

  const [arrayOption, setArrayOption] = useState([]);

  const [variables, setVariables] = useState([]);

  const [previewDocs, setPreviewDocs] = useState([]);
  const [numberDocLast, setNumberDocLast] = useState(0);
  const [numberDocs, setNumberDocs] = useState(0);

  const { user } = useContext(AuthContext);

  const companyId = user.companyId;

  const handleElements = (incomingFiles) => {
    let newNameFiles = incomingFiles || [];

    // Compatibilidad Backend: Si devuelve objetos {name, originalname}, extraer nombres
    if (newNameFiles.length > 0 && typeof newNameFiles[0] === 'object' && newNameFiles[0].name) {
      newNameFiles = newNameFiles.map(f => f.name);
    }
    let elementsSequence = [];

    const newArrMessage = elementsSeq.filter((item) =>
      item.includes("message")
    );
    const newArrInterval = elementsSeq.filter((item) =>
      item.includes("interval")
    );
    const newArrImg = elementsSeq.filter((item) => item.includes("img"));
    const newArrAudio = elementsSeq.filter((item) => item.includes("audio"));
    const newArrVideo = elementsSeq.filter((item) => item.includes("video"));

    //Todas as mensagens
    for (let i = 0; i < numberMessages; i++) {
      const inputElement = document.querySelector(`.${newArrMessage[i]}`);
      const value = inputElement ? inputElement.value : "";

      if (!value) {
        toast.error(i18n.t("flowBuilder.singleBlock.errorEmptyMessage") || "Campos de mensagem vazio!");
        setLoading(false);
        throw new Error("Empty message");
      }
      elementsSequence.push({
        type: "message",
        value: value,
        number: newArrMessage[i],
      });
      console.log("text");
    }
    //Todos os intervalos
    for (let i = 0; i < numberInterval; i++) {
      const inputElement = document.querySelector(`.${newArrInterval[i]}`);
      const unitElement = document.querySelector(`input[name="intervalUnit${newArrInterval[i].replace('interval', '')}"]`);
      
      let rawValue = inputElement ? inputElement.value : "0";
      let unit = unitElement ? unitElement.value : "seconds";

      let multiplier = 1;
      if (unit === "minutes") multiplier = 60;
      if (unit === "hours") multiplier = 3600;
      if (unit === "days") multiplier = 86400;

      const finalValue = parseInt(parseFloat(rawValue) * multiplier);

      if (finalValue <= 0 || finalValue > 2592000) {
        toast.error(i18n.t("flowBuilder.singleBlock.errorIntervalCtx") || "Intervalo inválido. Máximo 30 días.");
        setLoading(false);
        throw new Error("Invalid interval");
      }
      elementsSequence.push({
        type: "interval",
        value: finalValue,
        number: newArrInterval[i],
      });
    }

    const matchesExt = (fileName, extList) => {
      if (!fileName || typeof fileName !== "string") return false;
      const ext = fileName.split(".").pop().toLowerCase();
      return extList.includes(ext);
    };

    // Contadores para índices de nuevos archivos
    let countImgNew = 0;
    let countAudioNew = 0;
    let countVideoNew = 0;
    let countDocNew = 0;

    //Todas as imagens
    for (let i = 0; i < numberImg; i++) {
      const onlyImg =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) => matchesExt(file, ["png", "jpg", "jpeg", "webp", "gif", "svg"])
        );
      const onlyImgNameOriginal = medias.filter(
        (file) => matchesExt(file.name, ["png", "jpg", "jpeg", "webp", "gif", "svg"])
      );
      if (elementsSeqEdit.includes(newArrImg[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrImg[i]
        )[0];
        elementsSequence.push({
          type: "img",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          teste: "image",
        });
      } else {
        // Asignar el siguiente archivo nuevo disponible
        const fileValue = onlyImg[countImgNew];
        const originalName = onlyImgNameOriginal.filter(f => f.name && !f.url)[countImgNew]?.name || "image"; // Intentar buscar en medias solo los nuevos (sin url)

        // Fallback robusto si no hay archivo (aunque debería haber)
        if (!fileValue) {
          console.warn("No file found for new image element", countImgNew);
        }

        elementsSequence.push({
          type: "img",
          value: fileValue || "",
          original: originalName,
          number: newArrImg[i],
          teste: "image",
        });
        countImgNew++;
      }
    }
    //Todos os audios
    for (let i = 0; i < numberAudio; i++) {
      const onlyAudio =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) => matchesExt(file, ["mp3", "ogg", "mpeg", "opus", "wav", "m4a", "aac"])
        );
      const onlyAudioNameOriginal = medias.filter(
        (file) => matchesExt(file.name, ["mp3", "ogg", "mpeg", "opus", "wav", "m4a", "aac"])
      );

      if (elementsSeqEdit.includes(newArrAudio[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrAudio[i]
        )[0];
        elementsSequence.push({
          type: "audio",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          record: document
            .querySelector(`.check${newArrAudio[i]}`)
            .querySelector(".PrivateSwitchBase-input").checked,
        });
      } else {
        // Asignar el siguiente archivo nuevo disponible
        const fileValue = onlyAudio[countAudioNew];
        const originalName = onlyAudioNameOriginal.filter(f => f.name && !f.url)[countAudioNew]?.name || "audio";

        elementsSequence.push({
          type: "audio",
          value: fileValue || "",
          original: originalName,
          number: newArrAudio[i],
          record: document
            .querySelector(`.check${newArrAudio[i]}`)
            .querySelector(".PrivateSwitchBase-input").checked,
        });
        countAudioNew++;
      }
    }
    //Todos os videos
    for (let i = 0; i < numberVideo; i++) {
      const onlyVideo =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) => matchesExt(file, ["mp4", "avi", "mov", "mkv"])
        );
      const onlyVideoNameOriginal = medias.filter(
        (file) => matchesExt(file.name, ["mp4", "avi", "mov", "mkv"])
      );
      if (elementsSeqEdit.includes(newArrVideo[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrVideo[i]
        )[0];
        elementsSequence.push({
          type: "video",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
        });
      } else {
        // Asignar el siguiente archivo nuevo disponible
        const fileValue = onlyVideo[countVideoNew];
        const originalName = onlyVideoNameOriginal.filter(f => f.name && !f.url)[countVideoNew]?.name || "video";

        elementsSequence.push({
          type: "video",
          value: fileValue || "",
          original: true ? originalName : "video", // Mantener lógica original simplificada
          number: newArrVideo[i],
        });
        countVideoNew++;
      }
    }
    // Todos os documentos
    for (let i = 0; i < numberDocs; i++) {
      const onlyDocs =
        newNameFiles !== null &&
        newNameFiles.filter((file) => !matchesExt(file, ["png", "jpg", "jpeg", "webp", "gif", "svg", "mp3", "ogg", "mpeg", "opus", "wav", "m4a", "aac", "mp4", "avi", "mov", "mkv"]));
      const onlyDocNameOriginal = medias.filter((file) =>
        !matchesExt(file.name, ["png", "jpg", "jpeg", "webp", "gif", "svg", "mp3", "ogg", "mpeg", "opus", "wav", "m4a", "aac", "mp4", "avi", "mov", "mkv"])
      );

      if (elementsSeqEdit.includes(`document${i}`)) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === `document${i}`
        )[0];
        elementsSequence.push({
          type: "document",
          value: itemSelectedEdit?.value,
          original: itemSelectedEdit?.original,
          number: itemSelectedEdit?.number,
        });
      } else {
        // Asignar el siguiente archivo nuevo disponible
        const fileValue = onlyDocs[countDocNew];
        const originalName = onlyDocNameOriginal.filter(f => f.name && !f.url)[countDocNew]?.name || "document";

        elementsSequence.push({
          type: "document",
          value: fileValue || "",
          original: originalName,
          number: `document${i}`,
        });
        countDocNew++;
      }
    }

    console.log("elementsSequence", elementsSequence);

    return elementsSequence;
  };

  const deleteElementsTypeOne = (id, type) => {
    if (type === "message") {
      setNumberMessages((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `message${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `message${id}`)
      );
      document.querySelector(`.stackMessage${id}`).remove();
    }
    if (type === "interval") {
      setNumberInterval((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `interval${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `interval${id}`)
      );
      document.querySelector(`.stackInterval${id}`).remove();
    }
    if (type === "img") {
      setNumberImg((old) => old - 1);
      setPreviewImg((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `img${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `img${id}`));
      document.querySelector(`.stackImg${id}`).remove();
    }
    if (type === "audio") {
      setNumberAudio((old) => old - 1);
      setPreviewAudios((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `audio${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `audio${id}`));
      document.querySelector(`.stackAudio${id}`).remove();
    }
    if (type === "video") {
      setNumberVideo((old) => old - 1);
      setPreviewVideos((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `video${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `video${id}`));
      document.querySelector(`.stackVideo${id}`).remove();
    }
    if (type === "document") {
      setNumberDocs((old) => old - 1);
      setPreviewDocs((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `document${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `document${id}`)
      );
      document.querySelector(`.stackDocument${id}`).remove();
    }
  };

  const moveElementDown = (id) => {
    setElementsSeq((old) => {
      const array = old;
      const index = array.indexOf(id);
      moveItemParaFrente(index);
      console.log("id", id);
      if (index !== -1 && index < array.length - 1) {
        // Verifica se o elemento foi encontrado no array e não está na última posição
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(index, 1)[0];
        novoArray.splice(index + 1, 0, elementoMovido);
        return novoArray;
      }
      return array;
    });
  };

  const moveElementUp = (id) => {
    setElementsSeq((old) => {
      const array = old;
      const index = array.indexOf(id);
      moveItemParaTras(index);

      if (index !== -1 && index > 0) {
        // Verifica se o elemento foi encontrado no array e não está na primeira posição
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(index, 1)[0];
        novoArray.splice(index - 1, 0, elementoMovido);
        return novoArray;
      }
      return array;
    });
  };

  function moveItemParaFrente(posicao) {
    setElements((old) => {
      const array = old;

      if (posicao >= 0 && posicao < array.length - 1) {
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(posicao, 1)[0];
        novoArray.splice(posicao + 1, 0, elementoMovido);
        return novoArray;
      }

      return array; // Retorna o array original se a movimentação não for possível
    });
  }

  function moveItemParaTras(posicao) {
    setElements((old) => {
      const array = old;
      if (posicao > 0 && posicao < array.length) {
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(posicao, 1)[0];
        novoArray.splice(posicao - 1, 0, elementoMovido);
        return novoArray;
      }

      return array; // Retorna o array original se a movimentação não for possível
    });
  }

  const handleChangeMediasImg = (e, number) => {
    const files = e.target.files;
    if (!files || files.length === 0) {
      return;
    }

    if (files[0].size > 10000000) {
      toast.error(i18n.t("flowBuilder.singleBlock.errorImageSize") || "Arquivo é muito grande! 10MB máximo");
      return;
    }
    const imgBlob = URL.createObjectURL(files[0]);
    const fileName = files[0].name;

    // Update Elements State directly to trigger re-render with new image
    setElements((old) => old.map(item => {
      if (item.key === `stackImg${number}`) {
        return imgLayout(number, "", imgBlob);
      }
      return item;
    }));

    setPreviewImg((old) => [
      ...old,
      {
        number: number,
        url: imgBlob,
        name: fileName,
      },
    ]);
    const selectedMedias = Array.from(files);
    setMedias((old) => [...old, selectedMedias[0]]);
  };

  const handleChangeAudios = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 5000000) {
      toast.error(i18n.t("flowBuilder.singleBlock.errorAudioSize") || "Arquivo é muito grande! 5MB máximo");
      return;
    }

    const audioBlob = URL.createObjectURL(e.target.files[0]);
    setPreviewAudios((old) => [
      ...old,
      {
        number: number,
        url: audioBlob,
        name: e.target.files[0].name,
      },
    ]);

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    document.querySelector(
      `.audio${number}`
    ).innerHTML = `<audio controls="controls">
    <source src="${audioBlob}" type="audio/mp3" />
    ${i18n.t("flowBuilder.singleBlock.html5NotSupported") || "seu navegador não suporta HTML5"}
  </audio>`;
    document.querySelector(`.btnAudio${number}`).remove();
  };

  const handleChangeVideos = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 20000000) {
      toast.error(i18n.t("flowBuilder.singleBlock.errorVideoSize") || "Arquivo é muito grande! 20MB máximo");
      return;
    }
    const videoBlob = URL.createObjectURL(e.target.files[0]);
    setPreviewVideos((old) => [
      ...old,
      {
        number: number,
        url: videoBlob,
        name: e.target.files[0].name,
      },
    ]);

    var divConteudo = document.createElement("div");

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    divConteudo.innerHTML = `<video key="${videoBlob}" controls="controls" style="width: 200px;" src="${videoBlob}">
    ${i18n.t("flowBuilder.singleBlock.html5NotSupported") || "seu navegador não suporta HTML5"}
  </video>`;

    document.querySelector(`.video${number}`).appendChild(divConteudo);
    document.querySelector(`.btnVideo${number}`).remove();
  };

  const imgLayout = (number, valueDefault = "", localPreview = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackImg${number}`}
        key={`stackImg${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "img")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.singleBlock.imageLabel") || "Imagem"}</Typography>
        <Stack direction={"row"} justifyContent={"center"}>
          <img
            src={
              localPreview
                ? localPreview
                : valueDefault.length > 0
                  ? getMediaUrl(valueDefault, companyId)
                  : ""
            }
            className={`img${number}`}
            style={{ width: "200px", display: (localPreview || valueDefault.length > 0) ? "block" : "none" }}
          />
        </Stack>
        {valueDefault.length === 0 && !localPreview && (
          <Button
            variant="contained"
            component="label"
            className={`btnImg${number}`}
          >
            {i18n.t("flowBuilder.singleBlock.uploadImage") || "Enviar imagem"}
            <input
              type="file"
              accept="image/png, image/jpg, image/jpeg"
              hidden
              onChange={(e) => handleChangeMediasImg(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const audioLayout = (number, valueDefault = "", valueRecordDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackAudio${number}`}
        key={`stackAudio${number}`}
      >
        <Stack
          sx={{ position: "absolute", right: 6 }}
          direction={"row"}
          gap={1}
        >
          {/* <KeyboardArrowUp
            onClick={() => moveElementUp(`audio${number}`)}
            sx={{ cursor: "pointer" }}
          />
          <KeyboardArrowDown
            onClick={() => moveElementDown(`audio${number}`)}
            sx={{ cursor: "pointer" }}
          /> */}
          <Delete
            sx={{ cursor: "pointer" }}
            onClick={() => deleteElementsTypeOne(number, "audio")}
          />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.singleBlock.audioLabel") || "Audio"}</Typography>
        <div
          className={`audio${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 && (
            <audio controls="controls">
              <source
                src={getMediaUrl(valueDefault, companyId)}
                type="audio/mp3"
              />
              {i18n.t("flowBuilder.singleBlock.html5NotSupported") || "seu navegador não suporta HTML5"}
            </audio>
          )}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnAudio${number}`}
          >
            {i18n.t("flowBuilder.singleBlock.uploadAudio") || "Enviar audio"}
            <input
              type="file"
              accept="audio/ogg, audio/mp3, audio/opus"
              hidden
              onChange={(e) => handleChangeAudios(e, number)}
            />
          </Button>
        )}
        <Stack direction={"row"} justifyContent={"center"}>
          <Checkbox
            className={`checkaudio${number}`}
            defaultChecked={valueRecordDefault === "ok" ? false : true}
          />
          <Stack justifyContent={"center"}>
            <Typography>{i18n.t("flowBuilder.singleBlock.recordAudio") || "Enviar como audio gravado na hora"}</Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  };

  const videoLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackVideo${number}`}
        key={`stackVideo${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "video")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.singleBlock.videoLabel") || "Video"}</Typography>
        <div
          className={`video${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault && valueDefault.length > 0 && (
            <video key={getMediaUrl(valueDefault, companyId)} controls="controls" style={{ width: "200px" }} src={getMediaUrl(valueDefault, companyId)}>
              {i18n.t("flowBuilder.singleBlock.html5NotSupported") || "seu navegador não suporta HTML5"}
            </video>
          )}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnVideo${number}`}
          >
            {i18n.t("flowBuilder.singleBlock.uploadVideo") || "Enviar video"}
            <input
              type="file"
              accept="video/mp4"
              hidden
              onChange={(e) => handleChangeVideos(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const messageLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackMessage${number}`}
        key={`stackMessage${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "message")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.editor.nodes.text.name")}</Typography>
        <TextField
          label={i18n.t("flowBuilder.text.fields.message")}
          defaultValue={valueDefault}
          multiline
          rows={7}
          inputProps={{ className: `message${number}` }}
          name="text"
          variant="outlined"
          margin="dense"
          style={{ width: "100%" }}
        />
      </Stack>
    );
  };

  const intervalLayout = (number, valueDefault = 0) => {
    let defaultVal = valueDefault;
    let defaultUnit = "seconds";
    if (valueDefault > 0) {
      if (valueDefault % 86400 === 0) {
        defaultVal = valueDefault / 86400;
        defaultUnit = "days";
      } else if (valueDefault % 3600 === 0) {
        defaultVal = valueDefault / 3600;
        defaultUnit = "hours";
      } else if (valueDefault % 60 === 0) {
        defaultVal = valueDefault / 60;
        defaultUnit = "minutes";
      }
    }
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackInterval${number}`}
        key={`stackInterval${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "interval")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.editor.nodes.interval.name")}</Typography>
        <div style={{ display: "flex", gap: "10px", width: "100%", alignItems: "center", marginTop: "8px" }}>
          <TextField
            label="Valor"
            defaultValue={defaultVal}
            type="number"
            InputProps={{ inputProps: { min: 0, className: `interval${number}` } }}
            variant="outlined"
            margin="dense"
            style={{ flex: 1 }}
          />
          <FormControl variant="outlined" margin="dense" style={{ flex: 1 }}>
            <InputLabel>Unidad</InputLabel>
            <Select
              defaultValue={defaultUnit}
              label="Unidad"
              inputProps={{ name: `intervalUnit${number}` }}
            >
              <MenuItem value="seconds">Segundos</MenuItem>
              <MenuItem value="minutes">Minutos</MenuItem>
              <MenuItem value="hours">Horas</MenuItem>
              <MenuItem value="days">Días</MenuItem>
            </Select>
          </FormControl>
        </div>
      </Stack>
    );
  };

  const documentLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackDocument${number}`}
        key={`stackDocument${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "document")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.singleBlock.document")}</Typography>
        <div
          className={`document${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 ? (
            <embed
              src={getMediaUrl(valueDefault, companyId)}
              type="application/pdf"
              width="200px"
              height="200px"
            />
          ) : null}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnDocument${number}`}
          >
            {i18n.t("flowBuilder.singleBlock.uploadDocument")}
            <input
              type="file"
              accept=".doc,.docx,.pdf"
              hidden
              onChange={(e) => handleChangeDocuments(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const handleChangeDocuments = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 10000000) {
      toast.error(i18n.t("flowBuilder.singleBlock.toasts.fileTooLarge"));
      return;
    }

    const file = e.target.files[0];
    const documentBlob = URL.createObjectURL(file);

    // Verifica se o arquivo é PDF
    const isPDF = file.type === "application/pdf";

    setPreviewDocs((old) => [
      ...old,
      {
        number: number,
        url: documentBlob,
        name: file.name,
      },
    ]);

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    if (isPDF) {
      document.querySelector(`.document${number}`).innerHTML = `
        <embed src="${documentBlob}" type="application/pdf" width="200px" height="200px" />
      `;
    } else {
      document.querySelector(`.document${number}`).innerHTML = `
        <a href="${documentBlob}" target="_blank" rel="noopener noreferrer">${i18n.t("flowBuilder.singleBlock.viewDocument")}</a>
      `;
    }
    document.querySelector(`.btnDocument${number}`).remove();
  };

  useEffect(() => {
    const localVariables = localStorage.getItem("variables");
    if (localVariables) {
      setVariables(JSON.parse(localVariables));
    }

    if (open === "edit") {

      setActiveModal(true);

      const sequence = data?.data?.seq || [];
      const elementsEditLoc = data?.data?.elements || [];

      setElementsSeq(sequence);

      setElementsSeqEdit(sequence);
      setElementsEdit(elementsEditLoc);

      // Added name handling for edit mode
      if (data?.data?.name) {
        setName(data.data.name);
      }

      if (data) {
        sequence.map((item) => {
          const itemNode = elementsEditLoc.find(
            (inode) => inode.number === item
          );

          if (!itemNode) {
            console.warn(`[SingleBlock] Elemento ${item} no encontrado en los datos guardados.`);
            return;
          }

          if (itemNode.type === "message") {
            const numberLoc = parseInt(item.replace("message", ""));
            setElements((elm) => [
              ...elm,
              messageLayout(numberLoc, itemNode.value || ""),
            ]);
            setNumberMessages((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("message")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("message", ""))
              );
              setNumberMessagesLast((Math.max.apply(null, arrNumberMax) || 0) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "interval") {
            const numberLoc = parseInt(item.replace("interval", ""));
            setElements((elm) => [
              ...elm,
              intervalLayout(numberLoc, itemNode.value || 0),
            ]);
            setNumberInterval((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("interval")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("interval", ""))
              );
              setNumberIntervalLast((Math.max.apply(null, arrNumberMax) || 0) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "audio") {
            const numberLoc = parseInt(item.replace("audio", ""));
            setElements((elm) => [
              ...elm,
              audioLayout(numberLoc, itemNode.value || itemNode.url || "", itemNode.record ? "record" : "ok"),
            ]);
            setNumberAudio((old) => {
              const arsOnly = sequence.filter((item) => item.includes("audio"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("audio", ""))
              );
              setNumberAudioLast((Math.max.apply(null, arrNumberMax) || 0) + 1);
              setPreviewAudios((prevAudio) => [
                ...prevAudio,
                {
                  number: numberLoc,
                  url: (itemNode.value || itemNode.url) ? getMediaUrl(itemNode.value || itemNode.url, companyId) : "",
                  name: itemNode.original || "",
                },
              ]);
              setMedias((prevMedia) => [
                ...prevMedia,
                {
                  name: itemNode.original || "",
                },
              ]);
              return old + 1;
            });
          }
          if (itemNode.type === "img") {
            const numberLoc = parseInt(item.replace("img", ""));
            setElements((elm) => [
              ...elm,
              imgLayout(numberLoc, itemNode.value || itemNode.url || ""),
            ]);
            setNumberImg((old) => {
              const arsOnly = sequence.filter((item) => item.includes("img"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("img", ""))
              );
              setNumberImgLast((Math.max.apply(null, arrNumberMax) || 0) + 1);
              setPreviewImg((prevImg) => [
                ...prevImg,
                {
                  number: numberLoc,
                  url: (itemNode.value || itemNode.url) ? getMediaUrl(itemNode.value || itemNode.url, companyId) : "",
                  name: itemNode.original || "",
                },
              ]);
              setMedias((prevMedia) => [
                ...prevMedia,
                {
                  name: itemNode.original || "",
                },
              ]);

              return old + 1;
            });
          }
          if (itemNode.type === "video") {
            const numberLoc = parseInt(item.replace("video", ""));
            setElements((elm) => [
              ...elm,
              videoLayout(numberLoc, itemNode.value || itemNode.url || ""),
            ]);
            setNumberVideo((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("video")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("video", ""))
              );
              setNumberVideoLast((Math.max.apply(null, arrNumberMax) || 0) + 1);
              setPreviewVideos((prevVideo) => [
                ...prevVideo,
                {
                  number: numberLoc,
                  url: (itemNode.value || itemNode.url) ? getMediaUrl(itemNode.value || itemNode.url, companyId) : "",
                  name: itemNode.original || "",
                },
              ]);
              setMedias((prevMedia) => [
                ...prevMedia,
                {
                  name: itemNode.original || "",
                },
              ]);
              return old + 1;
            });
          }
          if (itemNode.type === "document") {
            const numberLoc = parseInt(item.replace("document", ""));
            setElements((elm) => [
              ...elm,
              documentLayout(numberLoc, itemNode.value || itemNode.url || itemNode.original || ""),
            ]);
            setNumberDocs((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("document")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("document", ""))
              );
              setNumberDocLast((Math.max.apply(null, arrNumberMax) || 0) + 1);
              setPreviewDocs((prevDoc) => [
                ...prevDoc,
                {
                  number: numberLoc,
                  url: (itemNode.original || itemNode.value || itemNode.url) ? getMediaUrl(itemNode.original || itemNode.value || itemNode.url, companyId) : "",
                  name: itemNode.original || "",
                },
              ]);
              setMedias((prevMedia) => [
                ...prevMedia,
                {
                  name: itemNode.original || "",
                },
              ]);
              return old + 1;
            });
          }
        });
      }
    } else if (open === "create") {

      setName(""); // Reset name
      setTextDig();
      setArrayOption([]);
      setActiveModal(true);
    } else {
      setActiveModal(false);
      setElements([]);
      setElementsSeq([]);
      setElementsSeqEdit([]);
      setElementsEdit([]);
      setNumberMessages(0);
      setNumberInterval(0);
      setNumberAudio(0);
      setNumberVideo(0);
      setNumberImg(0);
      setMedias([]);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = async () => {
    close(null);
    setActiveModal(false);
    setTimeout(() => {
      setMedias([]);
      setPreviewImg([]);
      setPreviewAudios([]);
      setPreviewVideos([]);
      setArrayOption([]);
      setElements([]);
      setElementsSeq([]);
      setElementsEdit([]);
      setElementsSeqEdit([]);
      setNumberMessages(0);
      setNumberMessagesLast(0);
      setNumberInterval(0);
      setNumberIntervalLast(0);
      setNumberAudio(0);
      setNumberAudioLast(0);
      setNumberVideo(0);
      setNumberVideoLast(0);
      setNumberImg(0);
      setNumberImgLast(0);
    }, 500);
  };

  const verifyButtonsUpload = () => {
    const newArrImg = elementsSeq.filter((item) => item.includes("img"));
    const newArrAudio = elementsSeq.filter((item) => item.includes("audio"));
    const newArrVideo = elementsSeq.filter((item) => item.includes("video"));
    const newArrDocs = elementsSeq.filter((item) => item.includes("document"));

    for (let i = 0; i < numberImg; i++) {
      const imgVerify = document.querySelector(
        `.btn${capitalize(newArrImg[i])}`
      );
      if (imgVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberAudio; i++) {
      const audioVerify = document.querySelector(
        `.btn${capitalize(newArrAudio[i])}`
      );
      if (audioVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberVideo; i++) {
      const videoVerify = document.querySelector(
        `.btn${capitalize(newArrVideo[i])}`
      );
      if (videoVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberDocs; i++) {
      const docVerify = document.querySelector(`.btnDocument${i}`);
      if (docVerify) {
        return true;
      }
    }
  };


  const handleSaveNode = async () => {
    setLoading(true);

    try {
      if (verifyButtonsUpload()) {
        setLoading(false);
        return toast.error(i18n.t("flowBuilder.singleBlock.toasts.deleteEmpty"));
      }

      const newFiles = medias.filter(media => media && media.type);
      let elementsData = null;

      if (newFiles.length > 0) {
        const formData = new FormData();
        formData.append("typeArch", "flow");

        newFiles.forEach(file => {
          formData.append("medias", file);
          formData.append("body", file.name);
        });

        const { data: responseData } = await api.post("/flowbuilder/content", formData);
        elementsData = handleElements(responseData);
      } else {
        elementsData = handleElements(null);
      }

      const mountData = {
        seq: elementsSeq,
        elements: elementsData,
      };

      if (open === "edit") {
        onUpdate({
          ...data,
          data: {
            ...data.data,
            ...mountData,
            name: name,
          },
        });
      } else {
        onSave({
          ...mountData,
        });
      }

      toast.success("Contenido guardado con éxito");
      handleClose();
    } catch (error) {
      console.error("Error saving node:", error);
      toast.error(i18n.t("flowBuilder.singleBlock.toasts.error") || "Error al guardar el contenido. Intente nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const scrollToBottom = (className) => {
    const element = document.querySelector(className);
    element.scrollTop = element.scrollHeight;
  };

  const variableFormatter = (item) => {
    return "{{" + item + "}}";
  };

  return (
    <div>
      <Dialog open={activeModal} fullWidth="lg" scroll="paper">
        <DialogTitle id="form-dialog-title">
          {data ? (i18n.t("flowBuilder.singleBlock.editTitle") || "Editar conteúdo") : (i18n.t("flowBuilder.singleBlock.addTitle") || "Adicionar conteúdo ao fluxo")}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <TextField
              label={i18n.t("flowBuilder.form.name") || "Nome"}
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              variant="outlined"
              margin="dense"
              style={{ marginBottom: 16 }}
            />
            <Stack
              className="body-card"
              style={{
                gap: "8px",
                padding: "16px",
                overflow: "auto",
                height: "60vh", // Reduced slightly to accommodate name field
                scrollBehavior: "smooth",
                scrollBehavior: "smooth",
                display: "flex",
                flexDirection: "column"
              }}
            >
              {elements.map((item) => (
                <div key={item.key || Math.random()}>{item}</div>
              ))}
              <Stack direction={"row"} gap={1} flexWrap="wrap" justifyContent="center">
                {/* Texto */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setElements((old) => [
                      ...old,
                      messageLayout(numberMessagesLast),
                    ]);
                    setNumberMessages((old) => {
                      setElementsSeq((oldEleme) => [
                        ...oldEleme,
                        `message${numberMessagesLast}`,
                      ]);
                      return old + 1;
                    });
                    setNumberMessagesLast((old) => old + 1);
                    setTimeout(() => {
                      scrollToBottom(".body-card");
                    }, 100);
                  }}
                >
                  <Message
                    sx={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />
                  {i18n.t("flowBuilder.editor.nodes.text.name")}
                </Button>
                {/* Intervalo */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setElements((old) => [
                      ...old,
                      intervalLayout(numberIntervalLast),
                    ]);
                    setNumberInterval((old) => {
                      setElementsSeq((oldEleme) => [
                        ...oldEleme,
                        `interval${numberIntervalLast}`,
                      ]);
                      return old + 1;
                    });
                    setNumberIntervalLast((old) => old + 1);
                    setTimeout(() => {
                      scrollToBottom(".body-card");
                    }, 100);
                  }}
                >
                  <AccessTime
                    sx={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />
                  {i18n.t("flowBuilder.editor.nodes.interval.name")}
                </Button>
                {/* Imagem */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setElements((old) => [...old, imgLayout(numberImgLast)]);
                    setNumberImg((old) => {
                      setElementsSeq((oldEleme) => [
                        ...oldEleme,
                        `img${numberImgLast}`,
                      ]);
                      return old + 1;
                    });
                    setNumberImgLast((old) => old + 1);
                    setTimeout(() => {
                      scrollToBottom(".body-card");
                    }, 100);
                  }}
                >
                  <Image
                    sx={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />
                  {i18n.t("flowBuilder.editor.nodes.image.name")}
                </Button>
                {/* Audio */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setElements((old) => [...old, audioLayout(numberAudioLast)]);
                    setNumberAudio((old) => {
                      setElementsSeq((oldEleme) => [
                        ...oldEleme,
                        `audio${numberAudioLast}`,
                      ]);
                      return old + 1;
                    });
                    setNumberAudioLast((old) => old + 1);
                    setTimeout(() => {
                      scrollToBottom(".body-card");
                    }, 100);
                  }}
                >
                  <MicNone
                    sx={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />
                  {i18n.t("flowBuilder.editor.nodes.audio.name")}
                </Button>
                {/* Video */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setElements((old) => [...old, videoLayout(numberVideoLast)]);
                    setNumberVideo((old) => {
                      setElementsSeq((oldEleme) => [
                        ...oldEleme,
                        `video${numberVideoLast}`,
                      ]);
                      return old + 1;
                    });
                    setNumberVideoLast((old) => old + 1);
                    setTimeout(() => {
                      scrollToBottom(".body-card");
                    }, 100);
                  }}
                >
                  <Videocam
                    sx={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />
                  {i18n.t("flowBuilder.editor.nodes.video.name")}
                </Button>
                {/* Documento */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setElements((old) => [...old, documentLayout(numberDocLast)]);
                    setNumberDocs((old) => {
                      setElementsSeq((oldEleme) => [
                        ...oldEleme,
                        `document${numberDocLast}`,
                      ]);
                      return old + 1;
                    });
                    setNumberDocLast((old) => old + 1);
                    setTimeout(() => {
                      scrollToBottom(".body-card");
                    }, 100);
                  }}
                >
                  <InsertDriveFile
                    sx={{
                      width: "16px",
                      height: "16px",
                      marginRight: "4px",
                    }}
                  />
                  {i18n.t("flowBuilder.singleBlock.document")}
                </Button>
              </Stack>

              <Box style={{ width: "100%", textAlign: "center", marginTop: "16px" }}>
                {variables && variables.length > 0 && (
                  <>
                    <div className="shadow- py-2 font-bold bg-blue-900 rounded text-white">
                      {i18n.t("flowBuilder.singleBlock.variables")}
                    </div>
                    <div className="w-full max-h-full overflow-y-auto space-y-2 py-2">
                      {variables.map((item, index) => (
                        <div key={index} className="rounded border-2 border-dashed border-zinc-800">
                          <p className="text-zinc-600">{variableFormatter(item)}</p>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </Box>
            </Stack>


          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className={classes.secondaryButton}>{i18n.t("contactModal.buttons.cancel")}</Button>
            <Button type="submit" onClick={() => handleSaveNode()} disabled={loading} className={classes.applyButton}>
              {data ? (i18n.t("common.save") || "Salvar") : (i18n.t("common.add") || "Adicionar")}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderSingleBlockModal;
